import { CluDemoVideo } from '@/components/appsumo/clu-demo-video.component';
import type { TourGain } from '@/lib/appsumo-upgrade';
import { cn } from '@/lib/utils';
import { brandAsset } from '@/lib/brand';

/**
 * The campaign's stills, copied from the landing page's product posters. Only
 * these: never `hubspot-integration.jpg` (the old Copilot home) or
 * `sequences-launch.jpg` (a title card), and no LinkedIn anywhere.
 */
export const APPSUMO_STILLS = {
  agents: brandAsset('/appsumo/clu-launch.jpg'),
  sequences: brandAsset('/appsumo/clu-champion-agent.jpg'),
  slack: brandAsset('/appsumo/clu-in-slack.jpg'),
} as const;

const STILL =
  'aspect-video w-full rounded-xl border border-border bg-muted object-cover';

/**
 * What a feature looks like, at 16:9: Clu at work (the demo loop, with the
 * reduced-motion rules of CluDemoVideo), an agent being described, a
 * personal email Clu wrote. Decorative: the words beside it carry the
 * meaning.
 */
export function AppSumoFeaturePicture({
  gain,
  className,
}: {
  gain: TourGain;
  className?: string;
}) {
  if (gain === 'clu') return <CluDemoVideo className={className} />;
  return (
    <img
      src={APPSUMO_STILLS[gain]}
      alt=''
      loading='lazy'
      decoding='async'
      className={cn(STILL, className)}
    />
  );
}
